 <!--Full width header Start-->
<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!--Full width header End-->

<div class="main-content">
  <!-- Breadcrumbs Start -->
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">College</h1>
      <ul>
        <li>
          <a class="active" href="/">Home</a>
        </li>
        <li>
          <a>About</a>
        </li>
        <li>
          Sri Vivekananda Degree & PG College
        </li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumbs End -->
  <!-- Blog Section Start -->
  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <about-menu></about-menu>
        </div>
        <div class="col-lg-8 pr-50 md-pr-15">
          <div class="blog-deatails">
            <div class="bs-img">
              <img src="assets/college/KADIRIBUILDING.png" alt="srivivekanandadegreecollege">
            </div>
            <div class="blog-full">
              <h2 class="title mb-40">About Sri Vivekananda Degree & PG College</h2>

              <div class="blog-desc">
                <p>
                  Sri Vivekananda degree & P.G College has been established under Sri Balaji Educational Society, Kadiri for the academic year 2006-2007. Dr. Palle Raghunatha Reddy garu, former Minister in the Govt of A.P and a recipient of 10 national service awards, is the founder and Correspondent of this prestigious educational Society. Being an academician himself, and with the motto of providing unmatched and quality educational to the students of Kadiri, Dr.Palle Raghunatha Reddy upgraded the Degree College to P.G. level in Anantapur District.
                </p>
                <p>
                  Presently Sri Vivekanandha degree & P.G College is running other advanced courses, it is recognised/affiliated as one of the colleges under the esteemed S.K. University
                </p>
              </div>           
             
              
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
